import { defineMessages } from "@uzverse/shared";

/** Company branding and floor strings (namespace "brand"). Turkish must mirror English. */
export const brandMessages = defineMessages("brand", {
  en: {
    demo: "Demo",
    level: "Level {{level}}",
    basement: "Basement {{level}}",
    website: "Website",
    theme: {
      lobby: "Lobby",
      software: "Software",
      studio: "Studio",
      marketing: "Marketing",
      accounting: "Accounting",
      leadership: "Leadership",
      generic: "General",
    },
    role: { architect: "Architect", interior_designer: "Interior designer" },
  },
  tr: {
    demo: "Demo",
    level: "{{level}}. seviye",
    basement: "Bodrum {{level}}",
    website: "Web sitesi",
    theme: {
      lobby: "Lobi",
      software: "Yazılım",
      studio: "Stüdyo",
      marketing: "Pazarlama",
      accounting: "Muhasebe",
      leadership: "Yönetim",
      generic: "Genel",
    },
    role: { architect: "Mimar", interior_designer: "İç mimar" },
  },
});
